import menu from './zh-CN/menu';
import pages from './zh-CN/pages';

export default {
  'navBar.lang': '语言',
  ...menu,
  ...pages,
};
